export default "/assets/images/app-screen1.f6edf103ec21d49f.webp";